import { createContext } from "react";
import { IConfig } from "./types";
import { defaultConfig } from "./utils";

export const ConfigContext = createContext<IConfig>(defaultConfig);